import loc from 'owa-localize';
import { formatUserTime, formatWeekDayTime, isAfter, isSameDay } from 'owa-datetime';
import {
    laterDate,
    eveningDate,
    tomorrowDate,
    weekendDate,
    firstWeekdayDate,
} from 'owa-schedule-datepicker/lib/utils/getDateSuggestions';
import {
    scheduleLaterToday,
    scheduleThisEvening,
    scheduleTomorrow,
    scheduleThisWeekend,
    scheduleNextWeek,
} from 'owa-locstrings/lib/strings/schedulesuggestions.locstring.json';
import { observableNow } from 'owa-observable-datetime';
import type SubMenuDate from '../store/schema/SubMenuDate';

// gets an array of times relative to now for snoozing
export default function getDateOptions(): SubMenuDate[] {
    const currentTime = observableNow();
    const laterToday = laterDate(currentTime);
    const tomorrow = tomorrowDate(currentTime);
    const evening = eveningDate(currentTime);
    const weekend = weekendDate(currentTime);
    const firstWeekday = firstWeekdayDate(currentTime);

    const scheduleSubMenuDates: SubMenuDate[] = [];

    scheduleSubMenuDates.push({
        date: laterToday,
        name: loc(scheduleLaterToday),
        secondaryText: formatUserTime(laterToday),
    });

    if (isAfter(evening, laterToday) && isSameDay(laterToday, currentTime)) {
        scheduleSubMenuDates.push({
            date: evening,
            name: loc(scheduleThisEvening),
            secondaryText: formatUserTime(evening),
        });
    }

    scheduleSubMenuDates.push({
        date: tomorrow,
        name: loc(scheduleTomorrow),
        secondaryText: formatWeekDayTime(tomorrow),
    });

    scheduleSubMenuDates.push({
        date: weekend,
        name: loc(scheduleThisWeekend),
        secondaryText: formatWeekDayTime(weekend),
    });

    scheduleSubMenuDates.push({
        date: firstWeekday,
        name: loc(scheduleNextWeek),
        secondaryText: formatWeekDayTime(firstWeekday),
    });

    return scheduleSubMenuDates;
}
